import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

const FormRow = (props) => {
    return (
        <Form.Group as={Row} key={props.id} className={props.noMargin ? "" : "mb-3"} controlId={props.id}>
            <Form.Label column sm="4" lg="3" className={props.noMargin ? "fw-bold py-0" : "fw-bold"}>
                <div>
                    {props.label} {props.required && <sup className="text-danger">*</sup>}
                </div>
                {props.hint && <small className="fw-light">{props.hint}</small>}
            </Form.Label>
            <Col sm="8" lg="9">
                {props.content}
            </Col>
        </Form.Group>
    )
}

export default FormRow